import { HttpErrorResponse, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { mockGarderies } from './garderie.mock';
import { mockHomeworkSettings } from './homework.mock';
import { mockMealOrders } from './meal.mock';

export const mockWalletResponse: any = (): Observable<HttpResponse<any> | HttpErrorResponse> => of(new HttpResponse());

export const mockNurseryResponse: any = (request: HttpRequest<any>): Observable<HttpResponse<any> | HttpErrorResponse> => {
    if (request.method === 'GET' && request.url.endsWith(SubUrlsEnum.NURSERY)) {
        const response: any = {
            status: 200,
            body: mockGarderies,
        };
        return of(new HttpResponse(response));
    }
    if (request.method === 'POST' && request.url.endsWith(SubUrlsEnum.NURSERY_ADD)) {
        const response: any = {
            status: 200,
            body: mockGarderies,
        };
        return of(new HttpResponse(response));
    }

    return of(new HttpResponse());
};

export const mockMealResponse: any = (request: HttpRequest<any>): Observable<HttpResponse<any> | HttpErrorResponse> => {
    if (request.method === 'GET' && request.url.endsWith(SubUrlsEnum.MEAL_ORDERS)) {
        const response: any = {
            status: 200,
            body: mockMealOrders,
        };
        return of(new HttpResponse(response));
    }

    return of(new HttpResponse());
};

export const mockHomeworkSettingsResponse: any = (request: HttpRequest<any>): Observable<HttpResponse<any> | HttpErrorResponse> => {
    if (request.method === 'GET' && request.url.endsWith(SubUrlsEnum.HOMEWORK_SETTINGS)) {
        const response: any = {
            status: 200,
            body: mockHomeworkSettings,
        };
        return of(new HttpResponse(response));
    }

    return of(new HttpResponse());
};
